import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="relative min-h-[80vh] flex items-center justify-center px-4">
      <div className="fixed inset-0 bg-grid opacity-30 pointer-events-none" />
      <div className="text-center">
        <div className="font-display text-[120px] md:text-[200px] leading-none text-gradient-pink opacity-20">
          404
        </div>
        <h1 className="font-display text-4xl md:text-6xl text-white tracking-widest -mt-8 mb-4">
          LOST IN THE SQUAD
        </h1>
        <p className="text-pink-300/50 font-body mb-8 text-sm">
          This page doesn't exist — or maybe it got rugged.
        </p>
        <Link to="/" className="btn-pink inline-flex">
          Back to Base
        </Link>
      </div>
    </div>
  )
}
